module.exports = __webpack_public_path__ + "static/media/gxs.bec82dba.svg";